import { extractWithRules } from './extract-rules';
import { normalizeAll } from './normalize';
import type { ExtractionResult, NormalizedCaseNumber, UnresolvedCandidate } from './types';

/**
 * 本ツールの解析はこの関数だけで完結する。
 *
 * 規則ベースの抽出 → 正規化 → 重複排除、のみ。外部への通信は一切しない。
 * ブラウザでもサーバーでも（そしてプロトタイプ HTML でも）同じ結果になる。
 */
export function runRuleOnlyExtraction(text: string): ExtractionResult {
  const rules = extractWithRules(text);
  const { items, unresolved } = normalizeAll(rules.candidates);
  const mergedUnresolved = dedupeUnresolved([...rules.unresolved, ...unresolved], items);
  return { items, unresolved_candidates: mergedUnresolved };
}

function dedupeUnresolved(
  list: UnresolvedCandidate[],
  items: NormalizedCaseNumber[],
): UnresolvedCandidate[] {
  const resolved = new Set(items.map((i) => i.original_fragment));
  const seen = new Set<string>();
  const out: UnresolvedCandidate[] = [];
  for (const u of list) {
    const fragment = (u.original_fragment ?? '').trim();
    if (fragment.length === 0) continue;
    if (resolved.has(fragment)) continue;
    // 改元年の候補は表示文字列で重複判定する（表記が違っても同じ事件番号だから）
    const key = u.pending_era_selection
      ? `pending:${u.pending_era_selection.display}`
      : `${fragment} ${u.reason_code}`;
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ ...u, original_fragment: fragment });
  }
  return out;
}
